import {Component, OnInit, signal} from '@angular/core';
import {StatusService} from '../services/status/status.service';
import {Status} from '../classes/status.class';
import {MaterialService} from '../services/material/material.service';
import {Material} from '../classes/material.class';
import {JsonPipe} from "@angular/common";

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    imports: [
        JsonPipe
    ]
})
export class SettingsComponent implements OnInit {

    public readonly statuses = signal<Status[]>([]);
    public readonly materials = signal<Material[]>([]);

    constructor(
        private statusService: StatusService,
        private materialService: MaterialService
    ) {
    }

    ngOnInit() {
        this.statusService.getStatuses().then(statuses => {
            this.statuses.set(statuses);
        });
        this.materialService.getMaterials().then(materials => {
            this.materials.set(materials);
        });
    }

}
